import { Component, Host, h, Element } from '@stencil/core';
import { getFirstElementOfTemplate } from '../../../utils/documentHelper';
@Component({
  tag: 'cms-trigger-modal',
  shadow: false,
})
export class CmsTriggerModal {
  @Element() elRoot: HTMLElement;

  handleClick = () => {
    const elRootTemplate: HTMLTemplateElement = this.elRoot.querySelector('template');
    const rectElRoot = this.elRoot.getBoundingClientRect();
    const elm: Element = getFirstElementOfTemplate(elRootTemplate);
    elm.setAttribute('data-top', (rectElRoot.top + rectElRoot.height + 10).toString());

    if (elm) {
      document.body.appendChild(elm.cloneNode(true));
    }
  };

  render() {
    return (
      <Host onClick={this.handleClick}>
        <slot />
      </Host>
    );
  }
}
